/**
 * 查新检索权限策略
 * @module novelty-check-strategy
 */
import { UsageService } from '@/domains/credit/services/usage-service';
import { BasePermissionStrategy } from '@/domains/shared/strategies/base-permission-strategy';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FeatureKey } from '@telecom/shared/domain/permission';

/**
 * 查新检索权限策略
 */
@injectable()
export class NoveltyCheckStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = '查新:执行查新检索';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasNoveltySearchUsage;
    }
}
